import React from "react"
import iconEmail from "../images/contact/icon-email.png"

import "./contact-item.css"

const ContactItem = ({ iconSrc = iconEmail, text='text', style}) => {
  return (
    <div className='contactItem' style={style}>
      <div className='imgWrap'>
        <img src={iconSrc} alt=""/>
      </div>
      <p>{text}</p>
    </div>
  )
}

export default ContactItem
